import { CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LoadingModalWrapper = styled("div")(() => ({
  backgroundColor: "#F9FAFB",
  display: "flex",
  height: "100vh",
  overflow: "hidden",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

export const LoadingSpinner = styled(CircularProgress)(() => ({
  color: "#0055A4 !important",
}));

export const ContainerFooter = styled("div")(() => ({
  position: "absolute",
  bottom: 0,
  width: "100%",
}));

export const Sentence = styled("div")(() => ({
  color: "#475467",
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "24px",
  fontWeight: 700,
  lineHeight: "32px",
  marginTop: "28px",
}));
